import type { AxiosInstance } from 'axios';
import axios from 'axios';
import type { HTTP_METHODS } from '@studio/constants/axios';

export type HttpMethods = (typeof HTTP_METHODS)[keyof typeof HTTP_METHODS];

const axiosInstance: AxiosInstance = axios.create();

export { axiosInstance };
